import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getDigitalAccessUsers,
  putDigitalAccessDecision,
  type DigitalAccessDecisionUpdate,
} from "@/api/digital-access";
import { diagnosticKeys } from "@/hooks/useDiagnostic";

/**
 * Os usuários do Digital Access, para a tela de usuários técnicos (#1346 fatia 10).
 *
 * A chave fica debaixo do prefixo do snapshot, como as do plano de contas e da
 * estrutura organizacional: a decisão invalida `diagnosticKeys.snapshot`, e o
 * quadro do Ato 1 e esta lista são relidos juntos.
 */
export function useDigitalAccessUsers(projectId: string | undefined) {
  return useQuery({
    queryKey: [...diagnosticKeys.snapshot(projectId ?? ""), "digital-access-users"] as const,
    queryFn: () => getDigitalAccessUsers(projectId!),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}

/** Grava a decisão de um usuário e faz o Diagnóstico ler o quadro de novo. */
export function useDigitalAccessDecision(projectId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ username, body }: { username: string; body: DigitalAccessDecisionUpdate }) =>
      putDigitalAccessDecision(projectId!, username, body),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: diagnosticKeys.snapshot(projectId ?? "") }),
  });
}
